import { dashboardServiceApi } from '@/shared/api/dashboard-service.api';
import { AppStoreTag } from '@/shared/constants/app-store-tag.constant';

import { CreateHistogramVariables } from '../model/types/histogram-form-api.interface';

const histogramFormApi = dashboardServiceApi.injectEndpoints({
	endpoints: (build) => ({
		createHistogram: build.mutation<void, CreateHistogramVariables>({
			invalidatesTags: [AppStoreTag.Histogram],
			query: (body) => ({
				method: 'POST',
				url: 'histogram/',
				body: {
					boat_uuid: body.uuid,
					name: body.name,
					start_time: body.start,
					end_time: body.end,
				},
			}),
		}),
		deleteHistogram: build.mutation<string, string>({
			invalidatesTags: [AppStoreTag.Histogram],
			query: (id) => ({ method: 'DELETE', url: `histogram/${id}`, responseHandler: 'text' }),
		}),
	}),
});

export const { useCreateHistogramMutation, useDeleteHistogramMutation } = histogramFormApi;
